import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from '../../utils/customPropTypes';
import style from '../../../scss/components/Products/AllProducts';
import style1 from '../../../scss/components/Applications/ApplicationCategoryList';
import ApplicationCategoryView from './ApplicationCategoryView';
import scrollToElement from 'scroll-to-element';

export default class ApplicationCategoryList extends React.Component {
    static propTypes = {
        selectorTitle: PropTypes.string,
        allCategories: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string,
            icon: CustomPropTypes.Image
        })),
        category: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            subcategories: PropTypes.array,
            applications: PropTypes.number
        })
    }
    constructor(props) {
        super(props);
        this.state = {
            currentCategory: {},
            displayComponent: true,
            selectedCategory: ""
        };
    }

    handleDetailClick = (currentCat) => {
        if (currentCat.subcategories && currentCat.subcategories.length > 0) {
            window.location.href = currentCat.slug;
        }
        else if (currentCat.applications > 0 ) {
            window.location.href = currentCat.slug;
        }
    }
    getCurrentCategory = (category, catSlug) => {
        if (category.name === decodeURI(catSlug)) {
            return category;
        }
        else if (category.subcategories) {
            var currCategory = null;
            for(let i=0; currCategory == null && i < category.subcategories.length; i++){
                let cat = category.subcategories[i];
                cat.parent = category;
                currCategory = this.getCurrentCategory(cat, catSlug);
           }
           return currCategory;
        }
        return null;
    }

    componentDidMount() {
        let hf_categoriesJson = document.querySelector('[name="hf_categoriesJson"]')
        let categoriesJson = hf_categoriesJson.value || '{}';
        let currCategory = JSON.parse(categoriesJson);
        let parentCategorySlug = currCategory.slug;
        let catHash = window.location.hash.substr(1);
        if (catHash) {
            currCategory = this.getCurrentCategory(currCategory, catHash);
            window.location.hash = "";
        }
        this.setState({ currentCategory: currCategory, selectedCategory: parentCategorySlug });
    }
    render() {
        return (
            <>
                {this.state.currentCategory &&
                    this.state.currentCategory.subcategories &&
                    this.state.currentCategory.subcategories.length > 0 &&
                    <ApplicationCategoryView {...this.props} visible={this.state.displayComponent}
                        category={this.state.currentCategory}
                        onViewDetail={this.handleDetailClick}
                        selectedCategory={this.state.selectedCategory}></ApplicationCategoryView>
                }
            </>
        )
    }
}
